import { render } from "./PowerPointConfiguration.vue?vue&type=template&id=29878bbc&scoped=true&ts=true"
import script from "./PowerPointConfiguration.vue?vue&type=script&lang=ts"
export * from "./PowerPointConfiguration.vue?vue&type=script&lang=ts"

import "./PowerPointConfiguration.vue?vue&type=style&index=0&id=29878bbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29878bbc"]])

export default __exports__